import React from 'react';

export default function OrderSuccessModal({
  isOpen,
  orderId,
  paymentMode,
  onClose,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="success-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="success-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <span className="success-modal-badge">Order Confirmed</span>
        <h3 id="success-modal-title">Your print request is in.</h3>
        <p>
          We have saved your order and attached your uploaded files. Keep this order
          reference for tracking and admin lookup.
        </p>
        <div className="success-order-card">
          <span>Order ID</span>
          <strong>{orderId}</strong>
          <small>
            {paymentMode === 'live'
              ? 'Cashfree checkout completed successfully.'
              : 'Sandbox mode was used, so payment was stored as a demo order.'}
          </small>
        </div>
        <button type="button" className="btn-primary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
